var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('navView',{on:{"handleCommand":_vm.handleCommand}}),_c('VueOfficeDocx',{staticStyle:{"height":"100vh","padding-top":"120px"},attrs:{"src":_vm.pathDocx}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }